import { TaxFilingCode } from "@wingspanhq/users/dist/lib/interfaces";
import COUNTRY_ISO_CODES from "@wingspanhq/utils/dist/fixtures/country-iso-codes-list.json";
import { USStates } from "./USstates";

export const INCOME_ESTIMATE_OPTIONS = [
  { value: 40000, label: "$0-40k" },
  { value: 50000, label: "$0-50k" },
  { value: 80000, label: "$0-80k" },
  { value: 80000, label: "$40k-80k" },
  { value: 80000, label: "$50k-80k" },
  { value: 160000, label: "$80k-160k" },
  { value: 200000, label: "$160k-200k" },
  { value: 320000, label: "$160k-320k" },
  { value: 400000, label: "$320k-400k" },
  { value: 500000, label: "$200k-500k" },
  { value: 510000, label: "$500k+" },
  { value: 600000, label: "$400k-600k" },
  { value: 610000, label: "$600k+" }
];

export const SINGLE_OPTIONS = [
  INCOME_ESTIMATE_OPTIONS[0], // $0-40k
  INCOME_ESTIMATE_OPTIONS[3], // $40k-80k
  INCOME_ESTIMATE_OPTIONS[5], // $80k-160k
  INCOME_ESTIMATE_OPTIONS[6], // $160k-200k
  INCOME_ESTIMATE_OPTIONS[9], // $200k-500k
  INCOME_ESTIMATE_OPTIONS[10] // $500k+
];
export const MARRIED_OPTIONS = [
  INCOME_ESTIMATE_OPTIONS[2], // $0-80k
  INCOME_ESTIMATE_OPTIONS[5], // $80k-160k
  INCOME_ESTIMATE_OPTIONS[7], // $160k-320k
  INCOME_ESTIMATE_OPTIONS[8], // $320k-400k
  INCOME_ESTIMATE_OPTIONS[11], // $400k-600k
  INCOME_ESTIMATE_OPTIONS[12] // $600k+
];
export const HEAD_OF_HOUSEHOLD_OPTIONS = [
  INCOME_ESTIMATE_OPTIONS[1], // $0-50k
  INCOME_ESTIMATE_OPTIONS[4], // $50k-80k
  INCOME_ESTIMATE_OPTIONS[5], // $80k-160k
  INCOME_ESTIMATE_OPTIONS[6], // $160k-200k
  INCOME_ESTIMATE_OPTIONS[9], // $200k-500k
  INCOME_ESTIMATE_OPTIONS[10] // $500k+
];
export const FILLING_CODE_OPTIONS = [
  {
    value: TaxFilingCode.Single,
    label: "Single"
  },
  {
    value: TaxFilingCode.Married,
    label: "Married"
  },
  {
    value: TaxFilingCode.HeadOfHousehold,
    label: "Head of household"
  },
  {
    value: TaxFilingCode.MarriedFilingSeparately,
    label: "Married filing separately"
  },
  {
    value: TaxFilingCode.QualifiedWidower,
    label: "Qualified widower"
  }
];
export const EXPENSES_OPTIONS = [
  {
    value: 1000,
    label: "0-1k"
  },
  {
    value: 5000,
    label: "1k-10k"
  },
  {
    value: 11000,
    label: "10k+"
  }
];

export const US_STATES_OPTIONS = USStates.map(s => ({
  value: s.abbreviation,
  label: s.name,
  searchText: s.name + " " + s.abbreviation
}));

export const US_STATES_OPTIONS_SHORT_NAME = USStates.map(s => ({
  value: s.abbreviation,
  label: s.abbreviation,
  searchText: s.name
}));

export const usTerritoryCodes = ["PR", "GU", "VI", "AS", "MP", "UM"];

const taxCountries = COUNTRY_ISO_CODES.filter(
  country => !usTerritoryCodes.includes(country["alpha-2"])
);

export const COUNTRY_OPTIONS = taxCountries.map(i => ({
  value: i["alpha-2"],
  label: i.name,
  searchText: i.name + " " + i["alpha-2"]
}));
